import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwMaintainerSchema: SourcedocumentDataSchemaFor<"GMW_Maintainer"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "maintenanceResponsibleParty"],
  properties: pickGmwLibraryFields(["eventDate", "maintenanceResponsibleParty"]),
};
